module.exports = __webpack_public_path__ + "static/media/meee.86f4c8ea.JPG";